// @flow

import { __ } from '@insolus/i18n';
import { NETWORK_ERROR } from '@insolus/request';
import { FORM_ERROR } from 'config/api';

import type { ApiError } from 'stores/api/_types';

type Message = {
    code: string | number,
    error: (error: ApiError) => string
};

type Options = {
    network?: false | () => string,
    notFound?: false | () => string,
    forbidden?: false | () => string
};

const catchApiError = (
    error: ApiError,
    messages: Message[] = [],
    options: Options = {}
): string => {
    const commons = {
        network   : () => __('error:disconnected-network'),
        notFound  : () => __('error:not-found'),
        forbidden : false,
        ...options
    };

    const _messages = [{
        code  : FORM_ERROR,
        error : () => __('error:mandatory-fields')
    }].concat(messages);

    if (commons.forbidden && error.httpCode === 403) {
        return commons.forbidden();
    }

    if (commons.notFound && error.httpCode === 404) {
        return commons.notFound();
    }

    if (commons.network && error.code === NETWORK_ERROR) {
        return commons.network();
    }

    const result = _messages.reduce(
        (acc: string, message: Message): string => (
            error.code === message.code ? message.error(error) : acc
        ),
        __('error:common')
    );

    return result;
};

export default catchApiError;
